import React from 'react';
import { CNP, CP } from '../../helpers/fee-slider-devices';
import { CardFeesData } from 'src/features/common';
import {
  AmexIcon,
  DinersIcon,
  InternationalIcon,
  MastercardIcon,
  VisaIcon,
} from 'src/assets/icons/cards';
import './fees-table.scss';

interface FeesTableProps {
  tableView: string;
  estimatedFees: CardFeesData[];
  tierType: 'Variable' | 'Fixed';
  changeTableView: (val: string) => void;
}

const FeesTable = ({ tableView, estimatedFees, tierType, changeTableView }: FeesTableProps) => {
  function compareObjects(a: CardFeesData, b: CardFeesData) {
    const nameA = a.product_name.toUpperCase();
    const nameB = b.product_name.toUpperCase();

    if (nameA < nameB) {
      return -1;
    }

    if (nameA > nameB) {
      return 1;
    }
    return 0;
  }

  return (
    <div className="fees-table-container">
      <div className="table-tabs">
        <button
          className={`${tableView === CP && 'active'} round-left`}
          onClick={() => changeTableView(CP)}
          type="button"
        >
          Physical payment
        </button>
        <button
          className={`${tableView === CNP && 'active'} round-right`}
          onClick={() => changeTableView(CNP)}
          type="button"
        >
          Virtual payment
        </button>
      </div>

      <table>
        <thead>
          <tr>
            <th>&nbsp;</th>
            <th>
              <img src={AmexIcon} alt="amex" title="Amex" />
            </th>
            <th>
              <img src={DinersIcon} alt="diners club" title="Diners club" />
            </th>
            <th>
              <img src={MastercardIcon} alt="mastercard" title="Mastercard" />
            </th>
            <th>
              <img src={VisaIcon} alt="visa" title="Visa" />
            </th>
            <th>
              <img src={InternationalIcon} alt="international" title="International" />
            </th>
          </tr>
        </thead>
        <tbody>
          <tr className="border-bottom">
            <td className="column-heading">Credit Card</td>
            {estimatedFees &&
              estimatedFees
                .filter(
                  (item) =>
                    !item.card_type.includes('Debit') &&
                    item.pricing_tier === tierType &&
                    item.demographic === 'Domestic',
                )
                .sort(compareObjects)
                .map((item, index) => (
                  <td key={index}>{Number.parseFloat(item.percentage).toFixed(1)}%</td>
                ))}
            <td>&nbsp;</td>
          </tr>
          <tr className="border-bottom">
            <td className="column-heading">Debit Card</td>
            {estimatedFees &&
              estimatedFees
                .filter(
                  (item) =>
                    !item.card_type.includes('Debit') &&
                    item.pricing_tier === tierType &&
                    ['Diners', 'Amex'].includes(item.product_name),
                )
                .sort(compareObjects)
                .map((item, index) => (
                  <td key={index}>{Number.parseFloat(item.percentage).toFixed(1)}%</td>
                ))}
            {estimatedFees &&
              estimatedFees
                .filter(
                  (item) => item.card_type.includes('Debit') && item.pricing_tier === tierType,
                )
                .sort(compareObjects)
                .map((item, index) => (
                  <td key={index}>{Number.parseFloat(item.percentage).toFixed(1)}%</td>
                ))}
            <td>&nbsp;</td>
          </tr>
          <tr>
            <td className="column-heading">International</td>
            <td>&nbsp;</td>
            <td>&nbsp;</td>
            <td>&nbsp;</td>
            <td>&nbsp;</td>
            <td>
              {Number.parseFloat(
                estimatedFees.find((item) => item.product_name === 'International')?.percentage ??
                  '0',
              ).toFixed(1)}
              %
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

export default FeesTable;
